<template>
  <div data-testid="lease-schedule-new">
    <v-card v-if="typeOfUser === 'Free'" data-testid="lease-schedule-new__free-card">
      <v-card-text data-testid="lease-schedule-new__free-card-text">
        <br>
        <br>
        <br>
        <div class="font-size-lg text-center font-weight-bold" align-center data-testid="lease-schedule-new__free-card-message"> This feature is available on paid version </div>
        <br>
        <br>
      </v-card-text>
    </v-card>
    <div class="all-height d-flex justify-center" v-else data-testid="lease-schedule-new__main-panel">
      <div class="all-width">
        <v-card class="shadow-off" loader-height="2" :loading="loading" :disabled="loading" data-testid="lease-schedule-new__main-card">
          <v-card-text data-testid="lease-schedule-new__main-card-text">
            <div>
              <div class="d-flex" data-testid="lease-schedule-new__breadcrumbs">
                <router-link
                  class="mb-1 text-decoration-none lease-schedule-new__breadcrumb-home"
                  :to="{ path: FC_ROUTES.HOME, query: $route.query }"
                  data-testid="lease-schedule-new__breadcrumb-home"
                >Home</router-link>
                <p class="px-2 mb-1" data-testid="lease-schedule-new__breadcrumb-separator">/</p>
                <p class="mb-1" data-testid="lease-schedule-new__breadcrumb-desc">{{ metadata.description }}</p>
              </div>
              <div class="d-flex align-center" data-testid="lease-schedule-new__toolbar">
                <h3 class="font-weight-medium" data-testid="lease-schedule-new__title">Lease Schedule</h3>
                <v-btn class="shadow-off ml-2" icon @click="refreshData()" data-testid="lease-schedule-new__refresh-btn">
                  <v-icon data-testid="lease-schedule-new__refresh-btn-icon">mdi-refresh</v-icon>
                </v-btn>
              </div>
            </div>
            <div v-if="loading && (!metadata._id || !botdetails._id)" data-testid="lease-schedule-new__loading-spinner">
              <v-skeleton-loader type="table-heading, list-item-two-line, article, article"></v-skeleton-loader>
            </div>
            <div class="gray--text d-flex align-center justify-center all-width" v-else-if="!botdetails._id" data-testid="lease-schedule-new__no-permission-panel">
              <div class="body-1 mb-4" data-testid="lease-schedule-new__no-permission-message"> You do not have permission to use the Lease Schedule {{$constants.BOT_NAME}} </div>
            </div>
            <div v-else-if="metadata.stage === 3 && Object.keys(rundetails).length === 0" class="pa-8 title text-center grey--text" data-testid="lease-schedule-new__empty-state"> {{$constants.BOT_NAME}} did not run </div>
            <div v-else data-testid="lease-schedule-new__main-content">
              <div v-if="metadata.stage !== 3" data-testid="lease-schedule-new__alerts-panel">
                <v-alert v-if="!savedParameters && hasParameters" type="info" text dense border="left" data-testid="lease-schedule-new__alert-save-params">Save the Input parameters to proceed</v-alert>
                <v-alert v-else-if="!savedFiles && hasFiles" type="info" text dense border="left" data-testid="lease-schedule-new__alert-upload-files">Upload all the required files to start the analysis</v-alert>
              </div>
              <div class="d-flex" v-if="$nova.hasRight(right, 'edit') || $nova.hasRight(right, 'add') || $nova.hasRight(right, 'delete')" data-testid="lease-schedule-new__run-toolbar">
                <v-spacer></v-spacer>
                <v-btn color="primary" v-if="Object.keys(rundetails).length === 0" class="ml-2 shadow-off white--text"  @click="startRun()" data-testid="lease-schedule-new__start-run-btn">
                  <v-icon class="mr-1" data-testid="lease-schedule-new__start-run-btn-icon">mdi-play</v-icon><span data-testid="lease-schedule-new__start-run-btn-label">Start Run</span>
                </v-btn>
                <v-btn color="primary" v-else class="ml-2 shadow-off white--text"  @click="startRun()" data-testid="lease-schedule-new__rerun-btn">
                  <v-icon class="mr-1" data-testid="lease-schedule-new__rerun-btn-icon">mdi-play</v-icon><span data-testid="lease-schedule-new__rerun-btn-label">Re Run</span>
                </v-btn>
              </div>
              <v-tabs v-model="tab" color="primary" height="30" data-testid="lease-schedule-new__tabs">
                <v-tab :key="1" v-if="hasParameters" class="text-transform-none justify-start" data-testid="lease-schedule-new__tab-lease-configuration">
                  <v-icon class="mr-2" data-testid="lease-schedule-new__tab-lease-configuration-icon">mdi-play-box-multiple-outline</v-icon>Lease Configuration
                </v-tab>
                <v-tab :key="3" class="text-transform-none justify-start" data-testid="lease-schedule-new__tab-lease-master">
                  <v-icon class="mr-2" data-testid="lease-schedule-new__tab-lease-master-icon">mdi-cloud-upload-outline</v-icon>Lease Master
                </v-tab>
                <v-tab :key="4" class="text-transform-none justify-start" @click="generateAnnexurelist(selectedresulttab, 'Summary')" data-testid="lease-schedule-new__tab-summary">
                  <v-icon class="mr-2" data-testid="lease-schedule-new__tab-summary-icon">mdi-apps-box</v-icon>Summary
                </v-tab>
                <v-tab :key="5" class="text-transform-none justify-start" @click="generateAnnexurelist(selectedresulttab, 'Detailed')" data-testid="lease-schedule-new__tab-schedules">
                  <v-icon class="mr-2" data-testid="lease-schedule-new__tab-schedules-icon">mdi-format-list-bulleted</v-icon>Schedules
                </v-tab>
                <v-tab :key="6" class="text-transform-none justify-start" @click="generateAnnexurelist(selectedresulttab, 'Journal Entry')" data-testid="lease-schedule-new__tab-journal-entries">
                  <v-icon class="mr-2" data-testid="lease-schedule-new__tab-journal-entries-icon">mdi-note-edit-outline</v-icon> Journal Entries
                </v-tab>
              </v-tabs>
              <v-divider data-testid="lease-schedule-new__tabs-divider"></v-divider>
              <v-tabs-items v-model="tab" data-testid="lease-schedule-new__tab-panels">
                <v-tab-item :key="1" v-if="hasParameters" data-testid="lease-schedule-new__tab-panel-lease-configuration">
                  <div class="d-flex" data-testid="lease-schedule-new__param-toolbar">
                    <v-spacer></v-spacer>
                    <v-btn v-if="metadata.stage !== 3 && ($nova.hasRight(right, 'edit') || $nova.hasRight(right, 'add') || $nova.hasRight(right, 'delete'))" class="mb-2 white--text mt-2" color="primary"  @click="saveInputParameters()" data-testid="lease-schedule-new__save-input-params-btn"><span>Save Input Parameters</span></v-btn>
                  </div>
                  <template v-for="(item, i) in setupList.parameter">
                    <div :key="i" v-if="!item.hidden" :data-testid="`lease-schedule-new__param-row-${i}`">
                      <div class="d-flex pa-2 hoverable align-start" :data-testid="`lease-schedule-new__param-row-content-${i}`">
                        <span class="mr-4" :data-testid="`lease-schedule-new__param-row-index-${i}`">{{ i + 1 }}.</span>
                        <div class="" :data-testid="`lease-schedule-new__param-row-labels-${i}`">
                          <span class="font-weight-bold" :data-testid="`lease-schedule-new__param-row-code-${i}`">{{ item.code }}</span>
                          <v-icon data-testid="lease-schedule-new__param-row-dot-icon">mdi-circle-small</v-icon>
                          <span :data-testid="`lease-schedule-new__param-row-name-${i}`">{{ item.name }}</span>
                        </div>
                        <v-spacer></v-spacer>
                        <div style="max-width: 200px" class="mr-4" :data-testid="`lease-schedule-new__param-row-verifications-${i}`">
                          <v-chip class="mr-1" label v-for="(v, k) in item.verification" :key="k" :data-testid="`lease-schedule-new__param-row-verification-chip-${i}-${k}`"><span>{{ v.code }}</span></v-chip>
                        </div>
                        <div :data-testid="`lease-schedule-new__param-row-input-panel-${i}`">
                          <div style="width: 250px">
                            <div v-if="item.type === 'number'" class="parameter-input" :data-testid="`lease-schedule-new__param-row-input-number-${i}`">
                              <lb-number v-model="inputparametersvalues[item._id]" :hidedetails="true" :disabled="!(metadata.stage !== 3) || (!$nova.hasRight(right, 'edit') && !$nova.hasRight(right, 'add'))" />
                            </div>
                            <div v-else-if="item.type === 'string'" class="parameter-input" :data-testid="`lease-schedule-new__param-row-input-string-${i}`">
                              <lb-string v-model="inputparametersvalues[item._id]" :hidedetails="true" :disabled="!(metadata.stage !== 3) || (!$nova.hasRight(right, 'edit') && !$nova.hasRight(right, 'add'))" />
                            </div>
                            <div v-else-if="item.type === 'date'" class="parameter-input" :data-testid="`lease-schedule-new__param-row-input-date-${i}`">
                              <lb-date v-model="inputparametersvalues[item._id]" :hidedetails="true" :disabled="!(metadata.stage !== 3) || (!$nova.hasRight(right, 'edit') && !$nova.hasRight(right, 'add'))" />
                            </div>
                            <div v-else-if="item.type === 'year'" class="parameter-input" :data-testid="`lease-schedule-new__param-row-input-year-${i}`">
                              <lb-year v-model="inputparametersvalues[item._id]" :hidedetails="true" :disabled="!(metadata.stage !== 3) || (!$nova.hasRight(right, 'edit') && !$nova.hasRight(right, 'add'))" />
                            </div>
                            <div v-else-if="item.type === 'month'" class="parameter-input" :data-testid="`lease-schedule-new__param-row-input-month-${i}`">
                              <lb-month v-model="inputparametersvalues[item._id]" :hidedetails="true" :disabled="!(metadata.stage !== 3) || (!$nova.hasRight(right, 'edit') && !$nova.hasRight(right, 'add'))" />
                            </div>
                            <div v-else-if="item.type === 'time'" class="parameter-input" :data-testid="`lease-schedule-new__param-row-input-time-${i}`">
                              <lb-time v-model="inputparametersvalues[item._id]" :hidedetails="true" :disabled="!(metadata.stage !== 3) || (!$nova.hasRight(right, 'edit') && !$nova.hasRight(right, 'add'))" />
                            </div>
                            <div v-else-if="item.type === 'daterange'" class="parameter-input" :data-testid="`lease-schedule-new__param-row-input-daterange-${i}`">
                              <lb-daterange v-model="inputparametersvalues[item._id]" :hidedetails="true" :disabled="!(metadata.stage !== 3) || (!$nova.hasRight(right, 'edit') && !$nova.hasRight(right, 'add'))" />
                            </div>
                            <div v-else-if="item.type === 'timerange'" class="parameter-input" :data-testid="`lease-schedule-new__param-row-input-timerange-${i}`">
                              <lb-timerange v-model="inputparametersvalues[item._id]" :hidedetails="true" :disabled="!(metadata.stage !== 3) || (!$nova.hasRight(right, 'edit') && !$nova.hasRight(right, 'add'))" />
                            </div>
                            <div v-else-if="
                                [
                                  'numberarray',
                                  'stringarray',
                                  'datearray',
                                  'yeararray',
                                  'montharray',
                                  'timearray',
                                  'daterangearray',
                                  'timerangearray',
                                ].indexOf(item.type) > -1
                              " class="parameter-input" :data-testid="`lease-schedule-new__param-row-input-list-${i}`">
                              <lb-list :allowrepeat="true" :type="item.type" v-model="inputparametersvalues[item._id]" :hidedetails="true" :disabled="(metadata.stage !== 3) || (!$nova.hasRight(right, 'edit') && !$nova.hasRight(right, 'add'))" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <v-divider :data-testid="`lease-schedule-new__param-row-divider-${i}`"></v-divider>
                    </div>
                  </template>
                  <div class="mb-2 mt-2" data-testid="lease-schedule-new__gaap-panel">
                    <div class="ml-6" data-testid="lease-schedule-new__gaap-label"> Select the GAAP <v-icon class="ml-1" data-testid="lease-schedule-new__gaap-help-icon">mdi-help-circle-outline</v-icon>
                    </div>
                    <div class="ml-5 mt-2" data-testid="lease-schedule-new__gaap-radio-group-panel">
                      <v-radio-group v-model="gaapValues" row class="pt-0 mt-0" dense hide-details data-testid="lease-schedule-new__gaap-radio-group">
                        <v-radio class="my-0" v-for="n in gaapList" :key="n" :label="n" :value="n" :data-testid="`lease-schedule-new__gaap-radio-${n}`"></v-radio>
                      </v-radio-group>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item :key="3" data-testid="lease-schedule-new__tab-panel-lease-master">
                  <div class="mb-2 mt-2" data-testid="lease-schedule-new__lease-master-panel">
                    <div class="mb-2" data-testid="lease-schedule-new__lease-master-upload-row">
                      <div class="d-flex" data-testid="lease-schedule-new__lease-master-upload-toolbar">
                        <div v-if="isError" class="ml-2" data-testid="lease-schedule-new__lease-master-upload-error-panel">
                          <div class="error--text" data-testid="lease-schedule-new__lease-master-upload-error-message">{{ filecolumproerr || "Unknown Error" }}</div>
                        </div>
                        <v-spacer></v-spacer>
                        <FileUploads :files="setupList.file" :filevalues="uploaddetails" :editable="metadata.stage !== 3" :storepath="'/v2/bot/analysis/storefile/' + botdetails._id" :pid="id" :fileproerr="fileprocesserrors" :fileprostage="fileprocessstage" :fileuppercent="fileuploadpercent" :filesdataPros="filesdata" :fileconfig="fileConfigInfo" @startloading="loading = true" @stoploading="loading = false" @storedData="uploadLeaseMasterFile" :right="right" data-testid="lease-schedule-new__lease-master-upload-panel" />
                      </div>
                    </div>
                    <div class="d-flex mb-3" v-if="($nova.hasRight(right, 'edit') || $nova.hasRight(right, 'add'))" data-testid="lease-schedule-new__lease-master-toolbar">
                      <v-btn color="primary" class="white--text mr-1"  @click="newLease()" data-testid="lease-schedule-new__lease-master-new-btn">
                        <v-icon class="mr-1" data-testid="lease-schedule-new__lease-master-new-btn-icon">mdi-plus</v-icon><span data-testid="lease-schedule-new__lease-master-new-btn-label">New</span>
                      </v-btn>
                      <div data-testid="lease-schedule-new__lease-master-search-panel">
                        <lb-string class="seachwith" label="Search..." outlined hidedetails v-model="searchQuery" data-testid="lease-schedule-new__lease-master-search-input"></lb-string>
                      </div>
                      <v-spacer></v-spacer>
                      <!-- Clear Filter Button -->
                      <v-btn
                        v-if="hasActiveTableFilter"
                        outlined
                        small
                        class="mr-2"
                        color="primary"
                        @click="clearTableFilter()"
                        data-testid="lease-schedule-new__toolbar-clear-filter-btn"
                      >
                        <v-icon left data-testid="lease-schedule-new__toolbar-clear-filter-icon">mdi-filter-remove</v-icon>
                        <span>Clear Filter</span>
                      </v-btn>
                      <v-btn color="primary" class="mr-2" @click="$nova.downloadFile(id, {}, '/v2/bot/lease/getadhoctemplate')" data-testid="lease-schedule-new__lease-master-download-template-btn"><span>Download Template</span></v-btn>
                       <lb-file v-model="file" label="" class="py-0 my-0" :loading="fileprocessing['file'] === 1"
                      :drag="false" hidedetails @change="readFile('file')" :displayname="false"
                      accept=".xlsx,.xls,.xlsm,.xlsb" data-testid="lease-schedule-new__lease-master-upload-file-input" />
                    </div>
                    <lb-datatableaction ref="dataTableAction" v-if="paginatedItems.length>0" :headers="headers" :tabledata="paginatedItems" :itemsperpage="itemsPerPage" searchterm="" :bulkActions="false" @filter-active-change="onFilterActiveChange" data-testid="lease-schedule-new__lease-master-table">
                      <template v-slot:tbody>
                        <tr v-for="item in paginatedItems" :key="item._id" class="cursor-pointer  " :class="{ 'low-opacity': item.status === false }" :data-testid="`lease-schedule-new__lease-master-table-row-${item._id}`">
                          <template v-for="header in headers">
                            <td v-if="header.visible && header.value !== 'action'" :key="header.value" class="px-4 single-line" :class="{ 'description-header': header.value === 'description', 'single-line': header.value !== 'description' }" :data-testid="`lease-schedule-new__lease-master-table-cell-${item._id}-${header.value}`">
                              {{ item[header.value] }}
                            </td>
                          </template>
                          <td class="d-flex align-center px-3 single-line border-right border-left action-data" data-testid="lease-schedule-new__lease-master-table-actions-cell">
                            <div class="d-flex" data-testid="lease-schedule-new__lease-master-table-actions-panel">
                              <v-tooltip bottom content-class="tooltip-bottom" v-if="item.lease_status && ($nova.hasRight(right, 'edit') || $nova.hasRight(right, 'add'))" data-testid="lease-schedule-new__lease-master-table-edit-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn icon v-bind="attrs" v-on="on" @click="editItem(item)" data-testid="lease-schedule-new__lease-master-table-edit-btn">
                                    <v-icon data-testid="lease-schedule-new__lease-master-table-edit-btn-icon">mdi-pencil</v-icon>
                                  </v-btn>
                                </template>
                                <span>Edit Lease</span>
                              </v-tooltip>
                              <v-tooltip bottom content-class="tooltip-bottom" v-if="item.lease_status" data-testid="lease-schedule-new__lease-master-table-file-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn icon v-bind="attrs" v-on="on" @click="leaseFileFun(item._id, item.lease_document)" data-testid="lease-schedule-new__lease-master-table-file-btn">
                                    <v-icon data-testid="lease-schedule-new__lease-master-table-file-btn-icon">mdi-file</v-icon>
                                  </v-btn>
                                </template>
                                <span>Lease Document</span>
                              </v-tooltip>
                              <v-tooltip bottom content-class="tooltip-bottom" v-if="item.lease_status" data-testid="lease-schedule-new__lease-master-table-run-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn icon v-bind="attrs" v-on="on" @click="rundialog = true" data-testid="lease-schedule-new__lease-master-table-run-btn">
                                    <v-icon data-testid="lease-schedule-new__lease-master-table-run-btn-icon">mdi-cog-play</v-icon>
                                  </v-btn>
                                </template>
                                <span>Run Lease</span>
                              </v-tooltip>
                            </div>
                          </td>
                        </tr>
                      </template>
                    </lb-datatableaction>
                    <div class="d-flex align-center justify-center" v-else data-testid="lease-schedule-new__lease-master-table-empty"> NO DATA </div>
                    <Pagination :list="filteredItems" :itemsperpage="itemsPerPage" @paginated-data="setPaginatedData" data-testid="lease-schedule-new__lease-master-pagination" />
                  </div>
                </v-tab-item>
                <v-tab-item :key="4" data-testid="lease-schedule-new__tab-panel-summary">
                  <div data-testid="lease-schedule-new__summary-panel">
                    <div class="d-flex my-2" data-testid="lease-schedule-new__summary-toolbar-row">
                      <div style="min-width: 170px; max-width: 170px" data-testid="lease-schedule-new__summary-sidebar-panel">
                        <div v-if="Object.keys(rundetails).length > 1" data-testid="lease-schedule-new__summary-verificationlist-panel">
                          <template v-for="(v, k) in verificationlist">
                            <div :key="k" :class="`${selectedresulttab === k ? 'border-left-primary' : 'border-left-transparent'}`" :data-testid="`lease-schedule-new__summary-verificationlist-row-${k}`">
                              <div @click="selectedresulttab = k; generateAnnexurelist(v);" :class="`px-2 py-1 d-flex align-start cursor-pointer hoverable ${selectedresulttab === k ? 'grey lighten-4' : ''}`" :data-testid="`lease-schedule-new__summary-verificationlist-row-content-${k}`">
                                <div class="mr-2" :data-testid="`lease-schedule-new__summary-verificationlist-row-status-${k}`">
                                  <v-tooltip bottom content-class="tooltip-bottom" v-if="(rundetails[v._id] || {}).stage === 1" :data-testid="`lease-schedule-new__summary-verificationlist-row-status-completed-tooltip-${k}`">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" color="success" :data-testid="`lease-schedule-new__summary-verificationlist-row-status-completed-icon-${k}`">mdi-check-circle</v-icon>
                                    </template>
                                    <span>Completed</span>
                                  </v-tooltip>
                                  <v-tooltip bottom content-class="tooltip-bottom" v-else-if="(rundetails[v._id] || {}).stage === 4" :data-testid="`lease-schedule-new__summary-verificationlist-row-status-running-tooltip-${k}`">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" color="error" :data-testid="`lease-schedule-new__summary-verificationlist-row-status-running-icon-${k}`">mdi-radiobox-marked</v-icon>
                                    </template>
                                    <span>Currently running</span>
                                  </v-tooltip>
                                  <v-tooltip bottom content-class="tooltip-bottom" v-else :data-testid="`lease-schedule-new__summary-verificationlist-row-status-pending-tooltip-${k}`">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon v-bind="attrs" v-on="on" color="info" :data-testid="`lease-schedule-new__summary-verificationlist-row-status-pending-icon-${k}`">mdi-timer-sand</v-icon>
                                    </template>
                                    <span>Pending</span>
                                  </v-tooltip>
                                </div>
                                <div :data-testid="`lease-schedule-new__summary-verificationlist-row-label-${k}`">
                                  {{ v.name }}
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div v-else data-testid="lease-schedule-new__summary-annexurelist-panel">
                          <v-btn color="primary" class="white--text mb-4 shadow-off" @click="downloadResult()" data-testid="lease-schedule-new__summary-download-excel-btn">
                            <v-icon class="mr-1" data-testid="lease-schedule-new__summary-download-excel-btn-icon">mdi-file-excel</v-icon><span data-testid="lease-schedule-new__summary-download-excel-btn-label">Download Excel</span>
                          </v-btn>
                          <div class="" style="max-height:75vh !important;  overflow:scroll" data-testid="lease-schedule-new__summary-annexurelist-scroll-panel">
                            <template v-for="(v, k) in annexurelist">
                              <div :key="k" :class="`${selectedannexure === v.value ? 'border-left-primary' : 'border-left-transparent'}`" v-if="v.name.includes('Summary') " :data-testid="`lease-schedule-new__summary-annexurelist-row-${k}`">
                                <div @click="selectedannexure = v.value; readAnnexure(v.value, (verificationlist[selectedresulttab] || {})._id)" :class="`px-2 py-1 d-flex align-start cursor-pointer hoverable ${selectedannexure === v.value ? 'grey lighten-4' : ''}`" :data-testid="`lease-schedule-new__summary-annexurelist-row-content-${k}`">
                                  <div v-if="v.name.includes('Summary')" :data-testid="`lease-schedule-new__summary-annexurelist-row-label-${k}`">
                                    {{ v.name }}
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div class="flex-grow-1 px-4" style="min-width: 0" data-testid="lease-schedule-new__summary-table-panel">
                        <div class="d-flex" data-testid="lease-schedule-new__summary-table-toolbar">
                          <lb-dropdown v-if="Object.keys(rundetails).length > 1" label="Annexures" v-model="selectedannexure" :items="annexurelist" @change="
                                readAnnexure(
                                  selectedannexure,
                                  (verificationlist[selectedresulttab] || {})._id
                                )
                                " data-testid="lease-schedule-new__summary-table-dropdown" />
                          <v-spacer class="flex-grow-1"></v-spacer>
                        </div>
                        <div class="" v-if="currentannexuredata.length > 0" data-testid="lease-schedule-new__summary-table-wrapper">
                          <v-simple-table dense class="simple-table border-on" :fixed-header="true" data-testid="lease-schedule-new__summary-table">
                            <template v-slot:default>
                              <thead class="tableHeaderBg">
                                <tr class="">
                                  <template v-for="(v, k) in currentannexuredata[0]">
                                    <th :key="k" class="tableHeaderBg" v-if="k !== '_id'" :data-testid="`lease-schedule-new__summary-table-header-${k}`">
                                      {{ (k || "").replaceAll("_", " ") }}
                                    </th>
                                  </template>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-for="(v, k) in currentannexuredata">
                                  <tr :key="k" :data-testid="`lease-schedule-new__summary-table-row-${k}`">
                                    <template v-for="(vv, kk) in currentannexuredata[0]">
                                      <td :key="kk" v-if="kk !== '_id'" :data-testid="`lease-schedule-new__summary-table-cell-${k}-${kk}`">
                                        {{ typeof v[kk] === "number"
                                              ? $nova.formatNumber(v[kk].toFixed(0))
                                              : v[kk]
                                            }}
                                      </td>
                                    </template>
                                  </tr>
                                </template>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                        <div v-else class="text-center grey--text title pa-6" data-testid="lease-schedule-new__summary-table-empty"> No data available </div>
                      </div>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item :key="5" data-testid="lease-schedule-new__tab-panel-schedules">
                  <div>
                    <div class="d-flex my-2" data-testid="lease-schedule-new__schedules-toolbar-row">
                      <div style="min-width: 170px; max-width: 170px" data-testid="lease-schedule-new__schedules-sidebar-panel">
                        <div v-if="Object.keys(rundetails).length > 1">
                          <template v-for="(v, k) in verificationlist" data-testid="lease-schedule-new__schedules-verificationlist-panel">
                            <div :key="k" :class="`${selectedresulttab === k
                                ? 'border-left-primary'
                                : 'border-left-transparent'
                                }`">
                              <div @click="selectedresulttab = k; generateAnnexurelist(v);" :class="`px-2 py-1 d-flex align-start cursor-pointer hoverable ${selectedresulttab === k ? 'grey lighten-4' : ''}`">
                                <div class="mr-2" data-testid="lease-schedule-new__schedules-verificationlist-icon">
                                  <v-tooltip bottom content-class="tooltip-bottom" v-if="(rundetails[v._id] || {}).stage === 1">
                                    <template v-slot:activator="{ on, attrs }" data-testid="lease-schedule-new__schedules-verificationlist-completed-tooltip">
                                      <v-icon v-bind="attrs" v-on="on" color="success">mdi-check-circle</v-icon>
                                    </template>
                                    <span>Completed</span>
                                  </v-tooltip>
                                  <v-tooltip bottom content-class="tooltip-bottom" v-else-if="
                                      (rundetails[v._id] || {}).stage === 4
                                    ">
                                    <template v-slot:activator="{ on, attrs }" data-testid="">
                                      <v-icon v-bind="attrs" v-on="on" color="error">mdi-radiobox-marked</v-icon>
                                    </template>
                                    <span>Currently running</span>
                                  </v-tooltip>
                                  <v-tooltip bottom content-class="tooltip-bottom" v-else>
                                    <template v-slot:activator="{ on, attrs }" data-testid="">
                                      <v-icon v-bind="attrs" v-on="on" color="info">mdi-timer-sand</v-icon>
                                    </template>
                                    <span>Pending</span>
                                  </v-tooltip>
                                </div>
                                <div data-testid="lease-schedule-new__schedules-verificationlist-name">
                                  {{ v.name }}
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div v-else>
                          <v-btn color="primary" class="white--text mb-4 shadow-off" @click="downloadResult()" data-testid="lease-schedule-new__schedules-download-excel-btn">
                            <v-icon class="mr-1">mdi-file-excel</v-icon><span>Download Excel</span></v-btn>
                          <div class="" style="max-height:75vh !important;  overflow:scroll" data-testid="lease-schedule-new__schedules-annexurelist-scroll-panel">
                            <template v-for="(v, k) in annexurelist">
                              <div :key="k" :class="`${selectedannexure === v.value ? 'border-left-primary' : 'border-left-transparent'}`" v-if="v.name.includes('Detailed')">
                                <div @click="selectedannexure = v.value; readAnnexure(v.value, (verificationlist[selectedresulttab] || {})._id)" :class="`px-2 py-1 d-flex align-start cursor-pointer hoverable ${selectedannexure === v.value ? 'grey lighten-4' : ''}`">
                                  <div v-if="v.name.includes('Detailed')" data-testid="lease-schedule-new__schedules-verificationlist-name">
                                    {{ v.name }}
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div class="flex-grow-1 px-4" style="min-width: 0">
                        <div class="d-flex" data-testid="lease-schedule-new__schedules-table-toolbar">
                          <lb-dropdown v-if="Object.keys(rundetails).length > 1" data-testid="lease-schedule-new__schedules-annexure-dropdown" label="Annexures" v-model="selectedannexure" :items="annexurelist" @change="
                                readAnnexure(
                                  selectedannexure,
                                  (verificationlist[selectedresulttab] || {})._id
                                )
                                " />
                          <v-spacer class="flex-grow-1"></v-spacer>
                          <!-- <v-btn icon><v-icon>mdi-download</v-icon></v-btn> -->
                        </div>
                        <div class="" v-if="currentannexuredata.length > 0">
                          <v-simple-table dense class="simple-table mt-1" :fixed-header="true" :height="tableHeight" data-testid="lease-schedule-new__schedules-table">
                            <template v-slot:default>
                              <thead class="tableHeaderBg">
                                <tr class="" data-testid="lease-schedule-new__schedules-table-header">
                                  <template v-for="(v, k) in currentannexuredata[0]">
                                    <th class="tableHeaderBg" :key="k" v-if="k !== '_id'">
                                      {{ (k || "").replaceAll("_", " ") }}
                                    </th>
                                  </template>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(v, k) in currentannexuredata" :key="k" data-testid="lease-schedule-new__schedules-table-row">
                                  <template v-for="(vv, kk) in currentannexuredata[0]">
                                    <td :key="kk" v-if="kk !== '_id'" data-testid="lease-schedule-new__schedules-table-cell">
                                      <div v-if="kk === 'Discounting Factor'">
                                        {{ v[kk].toFixed(4) }}
                                      </div>
                                      <div v-else>
                                        {{ typeof v[kk] === "number"
                                              ? $nova.formatNumber(v[kk].toFixed(0))
                                              : v[kk]
                                          }}
                                      </div>
                                    </td>
                                  </template>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                        <div v-else class="text-center grey--text title pa-6"> No data available </div>
                      </div>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item :key="6" data-testid="lease-schedule-new__tab-panel-journal-entries">
                  <div>
                    <div class="d-flex my-2" data-testid="lease-schedule-new__tab-panel-journal-entries-content">
                      <div style="min-width: 170px; max-width: 170px" data-testid="lease-schedule-new__journal-entries-sidebar-panel">
                        <div v-if="Object.keys(rundetails).length > 1">
                          <template v-for="(v, k) in verificationlist" data-testid="lease-schedule-new__journal-entries-verificationlist-panel">
                            <div :key="k" :class="`${selectedresulttab === k
                                ? 'border-left-primary'
                                : 'border-left-transparent'
                                }`">
                              <div @click="selectedresulttab = k; generateAnnexurelist(v);" :class="`px-2 py-1 d-flex align-start cursor-pointer hoverable ${selectedresulttab === k ? 'grey lighten-4' : ''}`">
                                <div class="mr-2" data-testid="lease-schedule-new__journal-entries-verificationlist-item-icon">
                                  <v-tooltip bottom content-class="tooltip-bottom" v-if="(rundetails[v._id] || {}).stage === 1">
                                    <template v-slot:activator="{ on, attrs }" data-testid="lease-schedule-new__journal-entries-verificationlist-completed-tooltip">
                                      <v-icon v-bind="attrs" v-on="on" color="success">mdi-check-circle</v-icon>
                                    </template>
                                    <span>Completed</span>
                                  </v-tooltip>
                                  <v-tooltip bottom content-class="tooltip-bottom" v-else-if="
                                      (rundetails[v._id] || {}).stage === 4
                                    ">
                                    <template v-slot:activator="{ on, attrs }" data-testid="lease-schedule-new__journal-entries-verificationlist-running-tooltip">
                                      <v-icon v-bind="attrs" v-on="on" color="error">mdi-radiobox-marked</v-icon>
                                    </template>
                                    <span>Currently running</span>
                                  </v-tooltip>
                                  <v-tooltip bottom content-class="tooltip-bottom" v-else>
                                    <template v-slot:activator="{ on, attrs }" data-testid="lease-schedule-new__journal-entries-verificationlist-pending-tooltip">
                                      <v-icon v-bind="attrs" v-on="on" color="info">mdi-timer-sand</v-icon>
                                    </template>
                                    <span>Pending</span>
                                  </v-tooltip>
                                </div>
                                <div data-testid="lease-schedule-new__journal-entries-verificationlist-item-name">
                                  {{ v.name }}
                                </div>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div v-else data-testid="lease-schedule-new__journal-entries-annexurelist-panel">
                          <v-btn color="primary" class="mb-4 shadow-off" @click="downloadResult()" data-testid="lease-schedule-new__journal-entries-download-excel-btn">
                            <v-icon class="mr-1">mdi-file-excel</v-icon><span>Download Excel</span>
                          </v-btn>
                          <div class="" style="max-height:75vh !important;  overflow:scroll" data-testid="lease-schedule-new__journal-entries-annexurelist-scroll-panel">
                            <template v-for="(v, k) in annexurelist">
                              <div :key="k" :class="`${selectedannexure === v.value ? 'border-left-primary' : 'border-left-transparent'}`" v-if="v.name.includes('Journal Entry')" data-testid="lease-schedule-new__journal-entries-annexurelist-item-panel">
                                <div @click="selectedannexure = v.value; readAnnexure(v.value, (verificationlist[selectedresulttab] || {})._id)" :class="`px-2 py-1 d-flex align-start cursor-pointer hoverable ${selectedannexure === v.value ? 'grey lighten-4' : ''}`">
                                  <div v-if="v.name.includes('Journal Entry')" data-testid="lease-schedule-new__journal-entries-annexurelist-item-name">
                                    {{ v.name }}
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div class="flex-grow-1 px-4" style="min-width: 0" data-testid="lease-schedule-new__journal-entries-table-panel">
                        <div class="d-flex" data-testid="lease-schedule-new__journal-entries-table-toolbar">
                          <lb-dropdown v-if="Object.keys(rundetails).length > 1" data-testid="lease-schedule-new__journal-entries-table-toolbar-dropdown" label="Annexures" v-model="selectedannexure" :items="annexurelist" @change="
                                readAnnexure(
                                  selectedannexure,
                                  (verificationlist[selectedresulttab] || {})._id
                                )
                                " />
                          <v-spacer class="flex-grow-1"></v-spacer>
                          <!-- <v-btn icon><v-icon>mdi-download</v-icon></v-btn> -->
                        </div>
                        <div class="" v-if="currentannexuredata.length > 0" data-testid="lease-schedule-new__journal-entries-table-wrapper">
                          <v-simple-table dense class="" :fixed-header="true" :height="tableHeight" data-testid="lease-schedule-new__journal-entries-table">
                            <template v-slot:default>
                              <thead class="tableHeaderBg">
                                <tr class="grey lighten-3" data-testid="lease-schedule-new__journal-entries-table-header">
                                  <template v-for="(v, k) in currentannexuredata[0]">
                                    <th class="grey lighten-3" :key="k" v-if="k !== '_id'" data-testid="lease-schedule-new__journal-entries-table-header-cell">
                                      {{ (k || "").replaceAll("_", " ") }}
                                    </th>
                                  </template>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(v, k) in currentannexuredata" :key="k" data-testid="lease-schedule-new__journal-entries-table-row">
                                  <template v-for="(vv, kk) in currentannexuredata[0]">
                                    <td :key="kk" v-if="kk !== '_id'" data-testid="lease-schedule-new__journal-entries-table-cell">
                                      {{ typeof v[kk] === "number"
                                            ? $nova.formatNumber(v[kk].toFixed(0))
                                            : v[kk]
                                        }}
                                    </td>
                                  </template>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                        <div v-else class="text-center grey--text title pa-6"> No data available </div>
                      </div>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item :key="7" data-testid="lease-schedule-new__tab-panel-lease-schedule">
                  <div class="mb-2 mt-2">
                    <div class="mt-6" data-testid="lease-schedule-new__lease-schedule-panel">
                      <div class="ml-6 mb-2" > Select Lease Type </div>
                      <lb-dropdown class="ml-5 mr-5" label="Lease Schedule" :items="leaseTypes" data-testid="lease-schedule-new__lease-schedule-dropdown" />
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <lb-drawer v-model="dialogdoc" width="400" heading="Lease Document" :loading="loadingdocm" data-testid="lease-schedule-new__lease-document-drawer">
      <template v-slot:body>
        <div>
          <div class="text-center mb-1">Upload lease document.</div>
          <div class="d-flex align-center justify-center" data-testid="lease-schedule-new__lease-document-upload-panel">
            <span v-if="docdetailsObj.documentid" @click="downloadTemplate(docdetailsObj.documentid)" class="mx-2 cursor-pointer blue--text text--darken-2 caption" data-testid="lease-schedule-new__lease-document-name">
              <v-icon class="mr-1 blue--text text--darken-2">mdi-file</v-icon>
              {{ docdetailsObj.documentname }}
            </span>
            <lb-file label="" data-testid="lease-schedule-new__lease-document-upload" class="py-0 my-0 ml-1" v-model="leaseDocument" :drag="false" hidedetails :displayname="false" :loading="fileprocessing[leaseID] === 1" accept=".ppt, .pptx, .doc, .docx" @change="uploadFileDocument(leaseID)" />
          </div>
        </div>
      </template>
    </lb-drawer>
    <lb-drawer v-model="rundialog" width="350" heading="Confirmation Run Lease" :loading="loading" data-testid="lease-schedule-new__confirmation-run-lease-drawer">
      <template v-slot:body>
        <div>
          <div class="text-center font-size-lg">Confirm</div>
          <div class="text-center mb-1 mb-4">are you sure run the lease</div>
          <div class="d-flex align-center justify-center">
            <v-btn color="primary" class="ma-2" @click="runLeaseFun()" data-testid="lease-schedule-new__confirmation-run-lease-confirm-btn">
              <span>Confirm</span>
            </v-btn>
            <v-btn color="primary" @click="rundialog = false;" data-testid="lease-schedule-new__confirmation-run-lease-cancel-btn">
              <span>Cancel</span>
            </v-btn>
          </div>
        </div>
      </template>
    </lb-drawer>
    <lb-drawer v-model="closedialog" width="450" heading="Confirmation Close Lease" :loading="loadingClose" data-testid="lease-schedule-new__confirmation-close-lease-drawer">
      <template v-slot:body>
        <div>
          <div class="text-center font-size-lg">Confirm</div>
          <div class="text-center mb-1 mb-4">are you sure close the lease</div>
          <div class="justify-center closedate">
            <v-row>
              <v-col>
                <lb-date v-model="leaseendstart" label="lease start date" :disabled="true" :value="leaseendstart" data-testid="lease-schedule-new__lease-end-start-date" />
                <lb-date v-model="leaseenddate" label="lease end date" :disabled="true" :value="leaseenddate" data-testid="lease-schedule-new__lease-end-date" />
              </v-col>
            </v-row>
          </div>
          <div class="justify-center closedate">
            <lb-date v-model="closeleaseDate" label="lease close date" :error="errorcloseleaseDate" data-testid="lease-schedule-new__lease-close-date" />
          </div>
          <div class="d-flex align-center justify-center">
            <v-btn color="primary" class="ma-2" @click="closeLeaseFun()" data-testid="lease-schedule-new__confirmation-close-lease-confirm-btn">
              <span>Confirm</span>
            </v-btn>
            <v-btn color="primary" @click="closedialog = false; closeleaseDate = ''; errorcloseleaseDate = []" data-testid="lease-schedule-new__confirmation-close-lease-cancel-btn">
              <span>Cancel</span>
            </v-btn>
          </div>
        </div>
      </template>
    </lb-drawer>
    <lb-drawer v-model="opendialog" width="450" heading="Confirmation Open Lease" :loading="loadingOpen" data-testid="lease-schedule-new__confirmation-open-lease-drawer">
      <template v-slot:body>
        <div>
          <div class="text-center font-size-lg">Confirm</div>
          <div class="text-center mb-1 mb-4">are you sure open the lease</div>
          <div class="d-flex align-center justify-center">
            <v-btn color="primary" class="ma-2" @click="openLeaseFun()" data-testid="lease-schedule-new__confirmation-open-lease-confirm-btn">
              <span>Confirm</span>
            </v-btn>
            <v-btn color="primary" @click="opendialog = false;" data-testid="lease-schedule-new__confirmation-open-lease-cancel-btn">
              <span>Cancel</span>
            </v-btn>
          </div>
        </div>
      </template>
    </lb-drawer>
    <lb-drawer v-model="leaseDialog" :heading="leaseData._id ? 'Update Lease Item' : 'Add Lease Item'" width="800" :loading="leaseDialogloading" data-testid="lease-schedule-new__lease-item-drawer">
      <template v-slot:body>
        <div>
          <v-row>
            <v-col cols="6" class="my-0 py-1">
              <p class="ma-0 mb-1">lessor*</p>
              <lb-string v-model="leaseData.lessor" placeholder="Enter lessor" label="" :error="leaseError.lessor" data-testid="lease-schedule-new__lease-item-lessor" />
            </v-col>
            <v-col cols="6" class="my-0 py-1">
              <p class="ma-0 mb-1">Commencement Date*</p>
              <lb-date v-model="leaseData.commencement_date" :error="leaseError.commencement_date" :max="leaseData.end_date" data-testid="lease-schedule-new__lease-item-commencement-date" />
            </v-col>
            <v-col cols="6" class="my-0 py-1">
              <p class="ma-0 mb-1">End Date*</p>
              <lb-date v-model="leaseData.end_date" :error="leaseError.end_date" :min="leaseData.commencement_date" data-testid="lease-schedule-new__lease-item-end-date" />
            </v-col>
            <v-col cols="6" class="my-0 py-1">
              <p class="ma-0 mb-1">Installment*</p>
              <lb-number v-model="leaseData.installment" label="" placeholder="Enter Installment" :error="leaseError.installment" min="0" data-testid="lease-schedule-new__lease-item-installment" />
            </v-col>
            <v-col cols="6" class="my-0 py-1">
              <p class="ma-0 mb-1">Interest Rate*</p>
              <lb-number v-model="leaseData.interest_rate" label="" placeholder="Enter Interest Rate" :error="leaseError.interest_rate" min="0" data-testid="lease-schedule-new__lease-item-interest-rate" />
            </v-col>
            <v-col cols="6" class="my-0 py-1">
              <p class="ma-0 mb-1">Installment Frequency*</p>
              <lb-dropdown v-model="leaseData.installment_frequency" label="" :items="InstalmentFrequencyItem" :error="leaseError.installment_frequency" data-testid="lease-schedule-new__lease-item-installment-frequency" />
            </v-col>
            <v-col cols="6" class="my-0 py-1">
              <p class="ma-0 mb-1">Installment Time*</p>
              <lb-dropdown v-model="leaseData.installment_time" label="" :items="IncrementTimeItem" :error="leaseError.installment_time" data-testid="lease-schedule-new__lease-item-installment-time" />
            </v-col>
            <v-col cols="6" class="my-0 py-1">
              <p class="ma-0 mb-1">Increment Frequency*</p>
              <lb-number v-model="leaseData.increment_frequency" label="" :error="leaseError.increment_frequency" min="1" :value="1" data-testid="lease-schedule-new__lease-item-increment-frequency" />
            </v-col>
            <v-col cols="6" class="my-0 py-1">
              <p class="ma-0 mb-1">Increment Value*</p>
              <lb-number v-model="leaseData.increment_value" label="" :error="leaseError.increment_value" min="0" data-testid="lease-schedule-new__lease-item-increment-value" />
            </v-col>
            <v-col cols="6" class="my-0 py-1">
              <p class="ma-0 mb-1">Increment Rate*</p>
              <lb-number v-model="leaseData.increment_rate" label="" :error="leaseError.increment_rate" min="0" data-testid="lease-schedule-new__lease-item-increment-rate" />
            </v-col>
            <v-col cols="6" class="my-0 py-1">
              <p class="ma-0 mb-1">Increment Type</p>
              <lb-dropdown label="" :items="IncrementTypeItem" :error="leaseError.increment_type" v-model="leaseData.increment_type" values="Normal" data-testid="lease-schedule-new__lease-item-increment-type" />
            </v-col>
            <v-col cols="6" class="my-0 py-1" v-if="leaseData.increment_type === 'Recurring'">
              <p class="ma-0 mb-1">Increment on Increment*</p>
              <lb-number v-model="leaseData.increment_on_increment" label="" :error="leaseError.increment_on_increment" min="0" data-testid="lease-schedule-new__lease-item-increment-on-increment" />
            </v-col>
            <v-col cols="6" class="my-0 py-1">
              <p class="ma-0 mb-1">Security Deposit*</p>
              <lb-number v-model="leaseData.security_deposit" label="" :error="leaseError.security_deposit" min="0" data-testid="lease-schedule-new__lease-item-security-deposit" />
            </v-col>
            <v-col cols="6" class="my-0 py-1">
              <p class="ma-0 mb-1">Residual Value*</p>
              <lb-number v-model="leaseData.residual_value" label="" :error="leaseError.residual_value" min="0" data-testid="lease-schedule-new__lease-item-residual-value" />
            </v-col>
            <v-col cols="6" class="my-0 py-1">
              <p class="ma-0 mb-1">Initial Expense*</p>
              <lb-number v-model="leaseData.initial_expense" label="" :error="leaseError.initial_expense" min="0" data-testid="lease-schedule-new__lease-item-initial-expense" />
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:actions>
        <span class="caption">*Required</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="white--text " @click="leaseUpdate()" v-if="leaseData._id" data-testid="lease-schedule-new__lease-item-update">
          <span>Update</span>
        </v-btn>
        <v-btn color="primary" class="white--text " @click="leaseCreate()" v-else data-testid="lease-schedule-new__lease-item-save">
          <span>Save</span>
        </v-btn>
      </template>
    </lb-drawer>
    <lb-drawer v-model="modificationdialog" width="350" heading="Lease Modification" :loading="modificationdloading" data-testid="lease-schedule-new__lease-modification-drawer">
      <template v-slot:body>
        <div>
          <div class="text-center font-size-lg">Confirm</div>
          <div class="text-center mb-1 mb-4">are you sure modification the lease</div>
          <div class="d-flex align-center justify-center">
            <v-btn color="primary" class="ma-2" @click="modificationLeaseFun()" data-testid="lease-schedule-new__lease-modification-confirm-btn">
              <span>Confirm</span>
            </v-btn>
            <v-btn color="primary" @click="modificationdialog = false;" data-testid="lease-schedule-new__lease-modification-cancel-btn">
              <span>Cancel</span>
            </v-btn>
          </div>
        </div>
      </template>
    </lb-drawer>

    <lb-dailogboxnew v-model="leasedialogFile" :width="(uploaddata.length > 0) ? '' : '400'"
        heading="Lease Upload" :loading="loading" data-testid="lease-schedule-new__lease-upload-dialog">
        <template v-slot:body>
          <div>
            <div class="text-center mb-1">Lease uploaded</div>
            <div class="d-flex align-center justify-center">
              <lb-file v-model="file" label="" class="py-0 my-0" :loading="fileprocessing['file'] === 1"
                :drag="false" hidedetails @change="readFile('file')" :displayname="false"
                accept=".xlsx,.xls,.xlsm,.xlsb" data-testid="lease-schedule-new__lease-upload-file" />
              <v-btn color="fbcPrimary" class="ml-2 white--text"
                @click="$nova.downloadFile(id, {}, '/v2/bot/lease/getadhoctemplate')" data-testid="lease-schedule-new__lease-upload-template-btn"><span>Download Template</span></v-btn>
            </div>
          </div>        
          <div v-if="uploaddata.length > 0" class="mt-3" data-testid="lease-schedule-new__lease-upload-table-panel">
            <v-simple-table dense class="FC-Table" data-testid="lease-schedule-new__lease-upload-table">
              <template v-slot:default>
                <thead class="tableHeaderBg">
                  <th class="text-left pa-2" scope="description">Lease ID</th>
                  <th class="text-left pa-2" scope="category">scope_reduction_percentage</th>
                  <th class="text-left pa-2" scope="subcategory">scope_reduction_date</th>
                  <th class="text-left pa-2" scope="location">Scope_Reduction_Installment</th>
                  <th class="text-left pa-2" scope="assertions">one_time_payment_made</th>
                  <th class="text-left pa-2" scope="purpose">next_payment_cycle</th>
                  <th class="text-left pa-2" scope="instruction">subsequent_payouts_periods_count</th>
                  <th class="text-left pa-2" scope="preparer">RevisedIncrementValue</th>
                  <th class="text-left pa-2" scope="approver">RevisedIncrementRate</th>
                  <th class="text-left pa-2" scope="tags">RevisedIncrementFrequency</th>
                  <th class="text-left pa-2" scope="duedays">ScopeReductionEstimatedResidualGuaranteedValue</th>
                </thead>
                <v-slide-y-transition group tag="tbody" style="overflow:hidden !important;">
                <tr v-for="(v, k) in uploaddata" :key="k" data-testid="lease-schedule-new__lease-upload-table-row">
                  <template v-for="(vv, kk) in v">
                    <td :key="kk" data-testid="lease-schedule-new__lease-upload-table-cell">
                      {{ vv }}
                    </td>
                  </template>
                </tr>
  
              <tr v-for="(v, k) in errordata" :key="k" data-testid="lease-schedule-new__lease-upload-error-table-row">
                <template v-for="(vv, kk) in v">
                  <td :key="kk" class="error--text font-weight-bold" data-testid="lease-schedule-new__lease-upload-error-table-cell">
                    <v-tooltip bottom content-class="tooltip-bottom">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="error-text" data-testid="lease-schedule-new__lease-upload-error-tooltip">
                          {{ vv }}
                        </div>
                      </template>
                      <span>{{ "Not Matching lease_id" }}</span>
                    </v-tooltip>
                  </td>
                </template>
              </tr>
            </v-slide-y-transition>

              </template>
            </v-simple-table>
          </div>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <div v-if="!errordata.length > 0">
            <v-btn class="ml-2" color="fbcPrimary"  v-if="uploaddata.length > 0" @click="uploadeleaseFile()" data-testid="lease-schedule-new__lease-upload-verify-btn"><span>Verify &
              Upload</span></v-btn>
            <div v-else class="ml-2 error--text font-weight-bold">We found few errors. Rectify the same to proceed to upload
            </div>
          </div>
        </template>
      </lb-dailogboxnew>
  </div>
</template>
<script>
  //  import InputParamerter from '../../../../../views/conserve/InputParamerter.vue';
  import FileUploads from '../../../../views/conserve/FileUploads.vue';
  import Pagination from '../../components/Pagination/Pagination.vue';
  import { FC_ROUTES } from '../../utils/constants';
  export default {
    // name: 'financialclose_automation_bots_component',
    name: 'financialclose_automation_lease_bots',
    // props: ['props'],
    data: function() {
      return {
        FC_ROUTES,
        right: "financialclose_pbc_project",
        project: "",
        loading: false,
        hasActiveTableFilter: false,
        id: "",
        tab: 0,
        metadata: {},
        botproject: {},
        botdetails: {},
        setupList: {},
        verificationlist: [],
        parameters_detail: [],
        hasParameters: false,
        savedParameters: false,
        inputparametersvalues: {},
        uploaddetails: {},
        fileuploaddata: {},
        fileprocesserrors: {},
        fileuploadpercent: {},
        fileprocessstage: {},
        filesdata: {},
        processedFiles: false,
        savedFiles: false,
        hasFiles: false,
        rundetails: {},
        annexurelist: [],
        selectedresulttab: 0,
        selectedannexure: "",
        currentannexuredata: [],
        annexuredata: {},
        fileConfigInfo: {},
        botid: "6470e55d999d5833d9d58224",
        isValid: false,
        typeOfUser: "Paid",
        gaapList: ["ASC 842", "IFRS 16", "IND AS 116"],
        gaapValues: 'IFRS 16',
        dialog: false,
        searchQuery: '',
        headers: [{
          value: "lease_id",
          text: "Lease Id",
          sortable: false,
          filterable: false,
          visible: true,
        }, {
          value: "lessor",
          sortable: false,
          filterable: false,
          visible: true,
          text: "Lessor",
        }, {
          value: "commencement_date",
          sortable: false,
          filterable: false,
          visible: true,
          text: "Commencement Date",
        }, {
          value: "end_date",
          sortable: false,
          filterable: false,
          visible: true,
          text: "End Date",
        }, {
          value: "installment",
          sortable: false,
          filterable: false,
          visible: true,
          text: "Installment",
        }, {
          value: "interest_rate",
          sortable: false,
          filterable: false,
          visible: true,
          text: "Interest Rate",
        }, {
          value: "installment_frequency",
          sortable: false,
          filterable: false,
          visible: true,
          text: "Installment Frequency",
        }, {
          value: "increment_value",
          sortable: false,
          filterable: false,
          visible: true,
          text: "Increment Value",
        }, {
          value: "increment_rate",
          sortable: false,
          filterable: false,
          visible: true,
          text: "Increment Rate",
        }, {
          value: "increment_type",
          sortable: false,
          filterable: false,
          visible: true,
          text: "Increment Type",
        }, {
          value: "increment_on_increment",
          sortable: false,
          filterable: false,
          visible: true,
          text: "Increment on Increment",
        }, {
          value: "security_deposit",
          sortable: false,
          filterable: false,
          visible: true,
          text: "Security Deposit",
        }, {
          value: "residual_value",
          sortable: false,
          filterable: false,
          visible: true,
          text: "Residual Value",
        }, {
          value: "initial_expense",
          sortable: false,
          filterable: false,
          visible: true,
          text: "Initial Expense",
        }, {
          value: "increment_frequency",
          sortable: false,
          filterable: false,
          visible: true,
          text: "Increment Frequency",
        }, {
          value: "installment_time",
          sortable: false,
          filterable: false,
          visible: true,
          text: "InstallmentTime",
        }, {
          value: "action",
          sortable: false,
          filterable: false,
          visible: true,
          text: "Action",
        }, ],
        leaseTypes: ["Scope change", "Lease Term Change", "Lease Consideration Change"],
        leaseData: {
          increment_type: "Normal",
          installment_time: "End"
        },
        leaseDataList: [],
        leaseDialog: false,
        leaseError: false,
        leaseDialogloading: false,
        rundialog: false,
        summaries: [],
        detailed: [],
        journalEntries: [],
        formatedData: [],
        bulkleasefile: null,
        fileprocessing: {},
        leasefileprocessing:0,
        filecolumproerr: {},
        isError: false,
        clientid: "",
        storedData: [],
        leaseTabType: "",
        closedialog: false,
        loadingClose: false,
        opendialog: false,
        loadingOpen: false,
        errorcloseleaseDate: [],
        closeleaseDate: "",
        leaseID: '',
        leasedocID: '',
        leaseenddate: '',
        leaseendstart: '',
        leaseDocument: null,
        loadingdocm: false,
        dialogdoc: false,
        docdetailsObj: {},
        modificationdialog: false,
        modificationdloading: false,
        IncrementTypeItem: ["Normal", "OneTime", "Recurring"],
        IncrementTimeItem: ["Beginning", "End"],
        Increment_Type: '',
        InstalmentFrequencyItem: ["Monthly", "Quarterly", "SemiAnnual", "Annual"],
        itemsPerPage: 8,
        paginatedItems: [],
        tableHeight: '',
        leasesfile:null,
        uploaddata:[],
        errordata:[],
        file:null,
        leasedialogFile:false,
      }
    },
    props: {
      // botid: {
      //   type: String,
      //   default: ""
      // },
    },
    components: {
      FileUploads,
      Pagination
    },
    created() {
      this.refreshData();
      this.tableHeight = window.innerHeight - 300;
    },
    activated() {
      this.refreshData();
    },
    methods: {
      /**
       * Handler for filter-active-change event from DataTableAction
       */
      onFilterActiveChange(isActive) {
        this.hasActiveTableFilter = isActive;
      },
      /**
       * Clear table filters via DataTableAction ref
       */
      clearTableFilter() {
        if (this.$refs.dataTableAction) {
          this.$refs.dataTableAction.clearFilter();
        }
      },
      formateData() {
        let ObjectTemp = {};
        let ArrayTemp = [];
        this.leaseDataList.forEach((item, index) => {
          ObjectTemp = {
            __key: index,
            __formatedkey: index,
            _id: item._id,
            lease_id: item.lease_id,
            lessor: item.lessor,
            commencement_date: item.commencement_date,
            end_date: item.end_date,
            installment: item.installment,
            interest_rate: item.interest_rate,
            installment_frequency: item.installment_frequency,
            increment_value: item.increment_value,
            increment_rate: item.increment_rate,
            increment_type: item.increment_type,
            increment_on_increment: item.increment_on_increment,
            security_deposit: item.security_deposit,
            residual_value: item.residual_value,
            initial_expense: item.initial_expense,
            increment_frequency: item.increment_frequency,
            installment_time: item.installment_time,
            lease_status: item.status,
            lease_document: item.lease_document
          };
          ArrayTemp.push(ObjectTemp);
        });
        this.formatedData = ArrayTemp;
      },
      separateArrays() {
        this.annexurelist.forEach(item => {
          if (item.name.includes('Summary')) {
            this.summaries.push(item);
          } else if (item.name.includes('Detailed')) {
            this.detailed.push(item);
          } else if (item.name.includes('Journal Entry')) {
            this.journalEntries.push(item);
          }
        });
      },
      openFileDialog() {
        // Programmatically open file dialog when the icon is clicked
        this.$refs.fileInput.click();
      },
      setPaginatedData(paginationInfo) {
        if (paginationInfo && typeof paginationInfo === 'object' && 'data' in paginationInfo) {
          this.paginatedItems = paginationInfo.data || [];
          this.page = paginationInfo.page || 1;
        } else {
          this.paginatedItems = paginationInfo || [];
        }
      },
      init() {
        if (this.$store.state.subscriptions.financialclose.plan_detail.name) {
          this.typeOfUser = this.$store.state.subscriptions.financialclose.plan_detail.name || "Paid";
        }
      },
      refreshData() {
        this.id = this.$route.params.id || "";
        this.userid = this.$store.state.user.id;
        this.clientid = this.$store.state.client;
        this.currentannexuredata = [];
        this.annexuredata = {};
        this.getData();
        this.init();
        // this.generateAnnexurelist(0,this.leaseTabType);
      },
      getData() {
        this.loading = true;
        this.project = this.$route.params.id;
        this.isError = false;
        return this.axios.post("/v2/bot/analysis/getbotdetails/" + this.id).then(dt => {
          if (dt.data.status === "success" && dt.data.data.length > 0) {
            let data = dt.data.data[0] || {}
            this.metadata = data.metadata || {};
            this.userlist = [];
            this.userlist = this.metadata.userlist || [];
            this.managerlist = [];
            this.managerlist = this.metadata.managerlist || [];
            this.stage = this.metadata.stage;
          }
        }).then(() => {
          this.axios.post("/v2/bot/lease/get/" + this.id).then((ele) => {
            if (ele.data.status === "success" && ele.data.data.length > 0) {
              this.leaseDataList = ele.data.data || [];
              this.formateData();
            } else throw new Error(ele.data.message);
          })
        }).catch(error => {
          this.$store.commit("sbError", error?.response?.data?.message || error?.message || error || "Unknown error!");
        }).finally(() => {
          this.loading = false;
          this.loadBot();
        })
      },
      readFile(key) {
  let file = this.file;
  if ((file || {}).name && (this.fileprocessing[key] || 0) === 0) {
    this.fileprocessing[key] = 1;
    this.leasedialogFile = true;
    this.loading = true;
    let ext = ((file || {}).name || "").split(".").pop();
    let headings = ['lease_id', 'scope_reduction_percentage', 'scope_reduction_date', 'Scope_Reduction_Installment', 'one_time_payment_made', 'next_payment_cycle', 'subsequent_payouts_periods_count', 'RevisedIncrementValue', 'RevisedIncrementRate', 'RevisedIncrementFrequency', 'ScopeReductionEstimatedResidualGuaranteedValue'];
    
    Promise.resolve()
      .then(() => {
        if (["xlsx", "xls", "xlsm", "xlsb"].indexOf(ext) === -1) {
          throw new Error("Only xlsx, xls, xlsm, xlsb file extensions are supported");
        }
        return this.$nova.readExcelFile(file);
      })
      .then(dt => {
        console.log(dt);
        if (JSON.stringify(dt[0] || []) === JSON.stringify(headings)) {
          let listdata = []; // Array to store matched data
          let errordata = []; // Array to store unmatched data

          for (let i = 1; i < dt.length; i++) { // Start from 1 to skip the header row
            const el = dt[i];
            let idata = {};
            for (let j = 0; j < headings.length; j++) {
              const cel = headings[j];
              idata[cel] = el[j];
            }

            // Check if lease_id in idata matches any lease_id in leaseDataList
            let isMatch = false;
            for (let k = 0; k < this.leaseDataList.length; k++) {
              if (this.leaseDataList[k].lease_id === idata.lease_id) {
                isMatch = true;
                break; // Exit the loop if a match is found
              }
            }

            // Add to listdata if matched, otherwise add to errordata
            if (isMatch) {
              listdata.push(idata);
            } else {
              errordata.push(idata);
            }
          }

          this.uploaddata = listdata; // Assign matched data to uploaddata
          this.errordata = errordata; // Assign unmatched data to errordata

          if (errordata.length > 0) {
            console.warn("Unmatched lease IDs found:", errordata);
            this.$store.commit("sbError", "Some lease IDs in the file do not match the existing data.");
          }
        } else {
          throw new Error(`Columns ${headings.join(',')} are required in the same order`);
        }
      })
      .catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
      })
      .finally(() => {
        this.file = null;
        this.fileprocessing[key] = 0;
        this.loading = false;
      });
  }
},
      uploadeleaseFile(){
        this.loading = true;
        let url = '';
        if(this.project) url = "v2/bot/lease/bulkupdatelease/"+ this.project;
        const pid = this.project || this.id || '';
        const rows = Array.isArray(this.uploaddata) ? this.uploaddata : [];
        const data = rows.map((row, idx) => (idx === 0 ? { ...row, pid, project: pid } : row));
        this.axios.post(url, { pid, data }).then(dt => {
          if (dt.data.status === "success") {
              this.leasedialogFile = false;
              this.$store.commit("sbSuccess", "Lease uploaded successfully");
              this.getData();
          }
      }).catch(err => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        }).finally(() => {
          this.loading = false;
        })
      },
      generateAnnexurelist(index = 0, type) {
        this.leaseTabType = type;
        let ndata = [];
        let selectedverification = this.verificationlist[index] || {};
        let rundata = this.rundetails[selectedverification._id] || {};
        if (Object.keys(rundata).length > 0) {
          let annxdata = rundata;
          let hasannexure = false;
          for (let i = 0; i < annxdata.annexure.length; i++) {
            const el = annxdata.annexure[i];
            if (el.name.includes(type)) { // Check if the name includes the specified type
              ndata.push({
                name: el.name,
                value: el.collection
              });
              if (el.collection === this.selectedannexure) hasannexure = true;
            }
          }
          if (!hasannexure && ndata.length > 0) {
            this.selectedannexure = ndata[0].value;
          }
          this.readAnnexure(this.selectedannexure, selectedverification._id);
        }
        this.annexurelist = ndata;
      },
      readAnnexure(c, v) {
        if (c) {
          this.loading = true;
          Promise.resolve().then(() => {
            return this.axios.post("/v2/bot/analysis/readannexure/" + this.botdetails._id + "/c/" + c + "/v/" + v);
          }).then((dt) => {
            if (dt.data.status === "success") {
              this.annexuredata[c] = dt.data.data;
              this.currentannexuredata = this.annexuredata[c];
            } else throw new Error(dt.data.message || "Error reading annexure");
          }).catch((err) => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
            this.currentannexuredata = [];
            console.log(err);
          }).finally(() => {
            this.loading = false;
          });
          // }
        }
      },
      loadBot() {
        this.loading = true;
        return this.axios.post("/v2/bot/analysis/loadbotdetails/" + this.id + "/b/" + this.botid).then(dt => {
          if (dt.data.status === "success" && dt.data.data.length > 0) {
            let data = dt.data.data[0] || {};
            this.botdetails = data.metadata || {};
            this.uploaddetails = data.uploaddetails || {};
            this.setupList = data.setup || {};
            this.verificationlist = this.setupList.verification || {};
            this.parameters_detail = (this.setupList.verification[0] || []).parameters_detail;
            this.inputparametersvalues = this.botdetails.inputparameter || {};
            this.fileConfigInfo = this.setupList?.fileconfig || {};
            this.rundetails = {};
            for (const i of data.rundetails || []) {
              this.rundetails[i.verification] = i;
            }
            this.generateAnnexurelist(0, this.leaseTabType);
            // to check if inputparameter are available and if the same is saved
            this.savedParameters = false;
            if ((this.setupList.parameter || []).length > 0) {
              this.hasParameters = true;
              let allparametersaved = true;
              for (let ele of this.setupList.parameter) {
                if (!Object.hasOwnProperty.call((this.botdetails.inputparameter || {}), ele._id)) {
                  allparametersaved = false;
                }
              }
              this.savedParameters = allparametersaved;
            } else {
              this.hasParameters = false;
            }
            // set default input parameter values
            let availableids = [];
            for (const k in this.inputparametersvalues) {
              if (Object.hasOwnProperty.call(this.inputparametersvalues, k)) {
                availableids.push(k);
              }
            }
            for (const i of this.setupList.parameter || []) {
              if (availableids.indexOf(i._id) === -1) {
                if (Object.hasOwnProperty.call(this.setupList.inputparameterconfig || {}, i._id)) this.inputparametersvalues[i._id] = (this.setupList.inputparameterconfig[i._id] || {}).value;
                else this.inputparametersvalues[i._id] = i?.value;
              }
            }
            // to check if files are available and if the same is saved and also flag processing errors
            if ((this.setupList.file || []).length > 0) {
              this.hasFiles = true;
              let allfileprocessed = true;
              let allfilesaved = true;
              let availablefiles = [];
              for (const i of this.botdetails.files || []) {
                availablefiles.push(i.fileid);
              }
              for (let ele of this.setupList.file) {
                let id = ele._id;
                if ((this.uploaddetails[id] || {}).processed !== 1) {
                  allfileprocessed = false;
                }
                if ((this.uploaddetails[id] || {}).processed === -1) this.fileprocesserrors[id] = "Error while processing file";
                if (availablefiles.indexOf(id) === -1 || (this.uploaddetails[id].processed || 0) === -1) allfilesaved = false;
              }
              this.savedFiles = allfilesaved;
              this.processedFiles = allfileprocessed;
            } else {
              this.hasFiles = false;
            }
          }
        }).catch(err => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
        }).finally(() => {
          this.loading = false;
        })
      },
      startRun() {
        this.loading = true;
        const pid = this.id || this.project || this.$route.params.id || '';
        this.axios.post("/v2/bot/analysis/startrun/" + this.botdetails._id, {
          pid,
          data: { pid },
        }).then((ele) => {
          if (ele.data.status === "success") {
            this.$store.commit("sbSuccess", "Run Started");
            this.loadBot();
          } else throw new Error("Error starting run");
        }).catch((err) => {
          this.$store.commit("sbError", err?.response?.data?.message || err?.message || "Unknown error!");
          console.log(err);
        }).finally(() => {
          this.loading = false;
        });
      },
      downloadResult() {
        this.loading = true;
        this.axios.post("/v2/bot/analysis/downloadfile/" + this.botdetails._id).then(dt => {
          if (dt.data.status === "success") {
            let data = dt.data.data[0] || {};
            if (data.stage === 0 || data.stage === 4) this.$store.commit("sbSuccess", "File is being generated please try after sometime");
            else if (data.stage === 2) this.$store.commit("sbSuccess", "There was an error while generating file");
            else if (data.upload) this.$nova.downloadFile(data.upload);
            else return "no file found to download"
          } else {
            throw new Error(dt.data.message || "Error re-opening project");
          }
        }).catch(err => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        }).finally(() => {
          this.loading = false;
        })
      },
      saveInputParameters() {
        const {
          parameters_detail,
          inputparametersvalues,
          $store,
          botdetails,
          axios
        } = this;
        const FC_IP_4 = parameters_detail.filter(item => item.code === 'FC_IP_4').map(item => item._id);
        const FC_IP_3 = parameters_detail.filter(item => item.code === 'FC_IP_3').map(item => item._id);
        const endDateValue = inputparametersvalues[FC_IP_4[0]];
        const startDateValue = inputparametersvalues[FC_IP_3[0]];
        if (!startDateValue || startDateValue === '' || !endDateValue || endDateValue === '') {
          $store.commit("sbError", "Please enter both start and end dates");
          return;
        }
        const startDate = new Date(startDateValue);
        const endDate = new Date(endDateValue);
        if (startDate > endDate) {
          $store.commit("sbError", "Start date should be before end date");
          return;
        }
        this.loading = true;
        const objectInput = {
          inputparameter: inputparametersvalues,
          pid: this.id || this.project || '',
        };
        axios.post(`/v2/bot/analysis/storeinputparameter/${botdetails._id}`, {
          pid: objectInput.pid,
          data: objectInput,
        }).then((ele) => {
          if (ele.data.status === "success") {
            $store.commit("sbSuccess", "Input Parameters Updated");
            this.loadBot();
          } else throw new Error("Error updating input parameters");
        }).catch((err) => {
          $store.commit("sbError", err.message || err || "Unknown error!");
          console.error(err);
        }).finally(() => {
          this.loading = false;
        });
      },
      editItem(item = {}) {
        this.leaseData = {
          ...item
        };
        this.leaseError = {};
        this.leaseDialog = true;
      },
      modifyItem(item = {}) {
        this.leaseData = {
          ...item
        };
        this.leaseDialog = true;
      },
      leaseUpdate() {
        this.leaseDialogloading = true;
        const pid = this.project || this.id || '';
        this.axios.post("/v2/bot/lease/edit/" + this.leaseData._id, {
          pid,
          data: { ...this.leaseData, pid, project: this.leaseData.project || pid },
        }).then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", "update successfully");
            this.leaseDialog = false;
            this.leaseData = {};
            this.refreshData();
          } else {
            this.leaseError = {};
            if (dt.data.data.length > 0) {
              if (dt.data.data[0].index0) this.leaseError = dt.data.data[0].index0;
            }
            // throw new Error(dt.data.message || "Error Updateing Lease Item");
          }
        }).catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        }).finally(() => {
          // this.leaseDialog = false;
          this.leaseDialogloading = false;
        });
      },
      openLeaseFun() {
        this.loadingOpen = true;
        this.axios.post("/v2/bot/lease/openlease/" + this.leaseID).then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", "Open successfully");
            this.opendialog = false;
            this.refreshData();
          } else {
            throw new Error(dt.data.message || "Error Closeing Lease Item");
          }
        }).catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        }).finally(() => {
          this.loadingOpen = false;
        });
      },
      closeLeaseFun() {
        this.loadingClose = true;
        this.axios.post("/v2/bot/lease/closelease/" + this.leaseID, {
          data: [{
            close_date: this.closeleaseDate
          }],
        }).then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", "Closed successfully");
            this.closedialog = false;
            this.closeleaseDate = "";
            this.errorcloseleaseDate = [];
            this.refreshData();
          } else {
            this.errorcloseleaseDate = [];
            if (dt.data.message.length > 0) {
              if (dt.data.message) this.errorcloseleaseDate = dt.data.message;
            }
            // throw new Error(dt.data.message || "Error Closeing Lease Item");
          }
        }).catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        }).finally(() => {
          this.loadingClose = false;
          // this.closedialog = false;
        });
      },
      runLeaseFun() {
        this.loading = true;
        const pid = this.id || this.project || this.$route.params.id || '';
        this.axios.post("/v2/bot/analysis/startrun/" + this.botdetails._id, {
          pid,
          data: { pid },
        }).then((ele) => {
          if (ele.data.status === "success") {
            this.$store.commit("sbSuccess", "Successfully The Run Lease");
            this.refreshData();
          } else throw new Error("Error starting run lease");
        }).catch((err) => {
          this.$store.commit("sbError", err?.response?.data?.message || err?.message || "Unknown error!");
          console.log(err);
        }).finally(() => {
          this.loading = false;
          this.rundialog = false;
        });
        // this.$store.commit("sbSuccess", "Successfully The Run Lease");
        // this.rundialog = false;
      },
      modificationLeaseFun() {
        this.$store.commit("sbSuccess", "Successfully The Modification Lease");
        this.modificationdialog = false;
      },
      newLease() {
        this.leaseData = {
            increment_type: "Normal",
            installment_time: "End",
            installment: 0,
            interest_rate: 0,
            increment_value: 0,
            increment_frequency: 1,
            increment_rate: 0,
            security_deposit: 0,
            residual_value: 0,
            initial_expense: 0,
            increment_on_increment: 0,
          },
          this.leaseError = {};
        this.leaseDialog = true;
      },
      leaseCreate() {
        this.leaseDialogloading = true;
        this.leaseData.project = this.project;
        const pid = this.project || this.id || '';
        this.axios.post("/v2/bot/lease/add", {
          pid,
          data: { ...this.leaseData, pid },
        }).then((dt) => {
          if (dt.data.status === "success") {
            this.$store.commit("sbSuccess", "add successfully");
            this.leaseDialog = false;
            this.refreshData();
          } else {
            this.leaseError = {};
            if (dt.data.data.length > 0) {
              if (dt.data.data[0].index0) this.leaseError = dt.data.data[0].index0;
            }
            // throw new Error(dt.data.message || "Error Adding Lease Item");
          }
        }).catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        }).finally(() => {
          this.leaseDialogloading = false;
          // this.leaseDialog = false;
        });
      },
      blukleaseFun(key) {
        let file = this.bulkleasefile;
        this.isError = false,
          this.filecolumproerr = {};
        this.fileprocessing[key] = 1;
        if ((file || {}).name) {
          let ext = (file || {}).name.split('.').pop().toLowerCase();
          if (!['xlsx', 'xls', 'xlsm', 'xlsb', 'csv'].includes(ext)) {
            this.isError = true;
            this.filecolumproerr = 'Only xlsx, xls, xlsm, xlsb, csv file extensions are supported';
            return;
          }
          let fl = new FormData();
          fl.append('file', file);
          fl.append('project', this.project);
          fl.append('pid', this.project || this.id || '');
          this.axios.post('/v2/bot/lease/bulkadd?cid=' + this.clientid, fl, {
            withCredentials: true,
            headers: {
              snclientid: this.clientid,
              'auth-data': JSON.stringify({}),
            }
          }).then(response => {
            if (response.data.status === "success" && response.data.data.length > 0) {
              this.$store.commit("sbSuccess", "File uploaded");
              this.isError = false;
              this.filecolumproerr = {};
              this.getData()
            } else {
              this.isError = true,
                this.filecolumproerr = "Error while creating lease master, please try again"
              this.$store.commit("sbError", "Error while creating lease master, please try again");
              throw new Error(response.data.message || "Error Adding Lease Item");
            }
          }).catch(error => {
            console.error(error);
            new Error(error || "Error Adding Lease Item");
          }).finally(() => {
            this.bulkleasefile = null;
            this.fileprocessing[key] = 0;
          });
        }
      },
      uploadLeaseMasterFile(filedata) {
        this.loading = true;
        let success = false;
        this.axios.post("/v2/upload/get/" + filedata.stored[0]?.files[0]?.value).then((dt) => {
          if (dt.data.status === "success") {
            success = true;
            this.loading = true;
            let fileDetails = dt.data.data[0] || {};
            if (fileDetails.proceed != 1) {
              setTimeout(() => {
                this.loading = true;
                this.bulkLease(filedata)
              }, 10000);
            } else {
              this.bulkLease(filedata);
            }
          } else throw new Error(dt.data.message || "Error Lease Item");
        }).catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        }).finally(() => {
          this.loading = (success) ? true : false;
          this.bulkleasefile = null;
        });
      },
      bulkLease(filedata) {
        this.loading = true;
        const pid = this.project || this.id || '';
        this.axios.post("/v2/bot/lease/bulkadd/" + this.project, {
         pid,
         data: [{
            "upload": filedata.stored[0]?.files?.at(-1)?.value,
            pid,
            project: pid,
          }]
        }).then((dt) => {
          if (dt.data.status === "success") {
            this.loading = false;
            this.$store.commit("sbSuccess", "add successfully");
            this.refreshData();
          } else throw new Error(dt.data.message || "Error Lease Item");
        }).catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        }).finally(() => {
          this.loading = false;
          this.bulkleasefile = null;
        });
      },
      leasesFileProcess(){
        // let file = this.leasesfile;
         if (this.leasesfile) {
          let file = this.leasesfile;
          let ext = ((file || {}).name || "").split(".").pop();
          this.leasefileprocessing = 1;
          if ((file || {}).name) {
            Promise.resolve().then(() => {
              if (["ppt", "pptx", "doc", "docx"].indexOf(ext) === -1) throw new "Only .ppt, .pptx, .doc, .docx file extension supported";
              return this.$nova.uploadFile(this.axios, file, {
                progressfunction: (e) => {
                  console.log(e);
                }
              })
            }).then(dt => {
              if (dt.data.status === "success" && dt.data.data.length > 0) {
                this.leasefileprocessing = 0;
                let data = {
                  upload: dt.data.data[0]._id,
                  pid: this.id || this.project || '',
                  project: this.id || this.project || '',
                };
                return this.axios.post("/v2/bot/lease/storeleasedocument/" + this.id, {
                  pid: data.pid,
                  data: [data]
                });
              } else throw new "Unable to upload file";
            }).then(dt => {
              if (dt.data.status === "success" && dt.data.data.length > 0) {
                this.$store.commit("sbSuccess", "File uploaded");
                this.refreshData();
              } else throw new "error uploading file";
            }).catch(err => {
              this.$store.commit("sbError", err.message || err || "Unknown error!");
              console.log(err);
            }).finally(() => {
              this.leasefileprocessing = 0;
              this.leasesfile = null;
            })
          }
        }
        
      },
      uploadFileDocument: function(id) {
        if (id) {
          let file = this.leaseDocument;
          let ext = ((file || {}).name || "").split(".").pop();
          this.fileprocessing[id] = 1;
          if ((file || {}).name) {
            Promise.resolve().then(() => {
              if (["ppt", "pptx", "doc", "docx"].indexOf(ext) === -1) throw new "Only .ppt, .pptx, .doc, .docx file extension supported";
              return this.$nova.uploadFile(this.axios, file, {
                progressfunction: (e) => {
                  console.log(e);
                }
              })
            }).then(dt => {
              if (dt.data.status === "success" && dt.data.data.length > 0) {
                this.fileprocessing[id] = 2;
                let data = {
                  upload: dt.data.data[0]._id,
                  pid: this.id || this.project || '',
                  project: this.id || this.project || '',
                };
                return this.axios.post("/v2/bot/lease/storeleasedocument/" + id, {
                  pid: data.pid,
                  data: [data]
                });
              } else throw new "Unable to upload file";
            }).then(dt => {
              if (dt.data.status === "success" && dt.data.data.length > 0) {
                this.$store.commit("sbSuccess", "File uploaded");
                this.refreshData();
              } else throw new "error uploading file";
            }).catch(err => {
              this.$store.commit("sbError", err.message || err || "Unknown error!");
              console.log(err);
            }).finally(() => {
              this.fileprocessing[id] = 0;
              this.leaseDocument = null;
            })
          }
        }
      },
      downloadTemplate(id) {
        this.$nova.downloadFile('', {}, '/v2/bot/lease/download/' + id + '/a');
      },
      leaseFileFun(id, docid) {
        this.leaseID = id;
        this.dialogdoc = true;
        this.docdetailsObj = {};
        if (docid) {
          this.loadingdocm = true;
          this.axios.post("/v2/upload/get/" + docid).then((dt) => {
            if (dt.data.status === "success") {
              let docdetails = dt.data.data[0] || {};
              this.docdetailsObj = {
                documentname: docdetails.uploadname,
                documentid: docdetails._id
              };
            }
          }).catch((err) => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
            console.log(err);
          }).finally(() => {
            this.loadingdocm = false;
          });
        }
      },
      modificationItem(item) {
        console.log(item);
        this.modificationdialog = true;
      }
    },
    computed: {
      filteredItems() {
        if (this.searchQuery === null) {
          return this.formatedData;
        }
        const searchQuery = this.searchQuery.toLowerCase();
        return this.formatedData.filter(item => {
          for (const key in item) {
            // Skip iteration if the current property is not a string or number
            if (typeof item[key] !== 'string' && typeof item[key] !== 'number') continue;
            // Convert the property value to string for comparison
            const value = String(item[key]).toLowerCase();
            // If the value includes the search query, return true
            if (value.includes(searchQuery)) return true;
          }
          // If none of the properties include the search query, return false
          return false;
        });
      }
    },
    watch: {
      'leaseData.increment_value': function(newValue) {
        if (newValue > 1) {
          this.leaseData.increment_rate = 0;
        }
      },
      'leaseData.increment_rate': function(newValue) {
        if (newValue > 1) {
          this.leaseData.increment_value = 0;
        }
      }
    }
  }
</script>
<style scoped>
  .lease-schedule-new__breadcrumb-home {
    color: inherit;
  }

  .v-file-input {
    --v-file-input-color-border: transparent !important;
  }

  .seachwith {
    width: 250px !important;
  }

  .closedate {
    width: 250px !important;
    margin-left: 80px !important;
  }

  .all-height {
    height: 95%;
  }
</style>